export function parseJSON(value: string) {
    try {
        return JSON.parse(value);
    } catch {
        return {};
    }
}
